import * as React from 'react';
import { VisitedSchool } from './VisitedSchool';
import { SchoolOption } from '../domain/SchoolOption';
import { Link } from './Link';
import { text } from 'src/common/text';

interface VisitedSchoolsProps {
  visitedSchoolOptions: SchoolOption[];
  onRemoveVisitedSchoolOption: (schoolId: number) => void;
}

export const VisitedSchools: React.FC<VisitedSchoolsProps> = ({
  visitedSchoolOptions: visitedSchools,
  onRemoveVisitedSchoolOption,
}) => {
  if (visitedSchools.length > 0) {
    return (
      <div style={{ marginTop: 64 }}>
        {visitedSchools.map((schoolOption: SchoolOption) => (
          <VisitedSchool key={schoolOption.id} schoolOption={schoolOption} onRemove={onRemoveVisitedSchoolOption} />
        ))}
      </div>
    );
  }

  return (
    <div style={{ marginTop: 24, display: 'flex', justifyContent: 'center' }}>
      <Link target="_blank" href="https://www.untis.at/" bold>
        {text('LBL_NO_WEBUNTIS')}
      </Link>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/VisitedSchools.tsx